

























































































import Component from "vue-class-component";
import StandardList from "front-component/components/List.vue";
import Orders from "@/components/miscellaneous/Orders.vue";
import Http from "front-component/Http";
import CatalogCompensationRepository from "@/repositories/zero-waste/CatalogCompensationRepository";
import {Prop, Watch} from "vue-property-decorator";
import _ from "lodash";

import CatalogCompensationOwner from "./fields/Owner.vue";
import CatalogCompensationStoreStatus from "./fields/StoreStatus.vue";
import CatalogCompensationAnabel from "./fields/Anabel.vue";
import CatalogCompensationTypeOwner from "./fields/TypeOwner.vue";
import CatalogCompensationHierarchyOwner from "./fields/HierarchyOwner.vue";
import CatalogCompensationIsValidated from "./fields/IsValidated.vue";
import CatalogCompensationCatalogCode from "./fields/CatalogCode.vue";
import CatalogCompensationCatalogName from "./fields/CatalogName.vue";
import CatalogCompensationProgram from "./fields/CompensationProgram.vue";
import CatalogCompensationFormattedWeek from "./fields/FormattedWeek.vue";
import CatalogCompensationValidationDeadline from "./fields/validationDeadline.vue";
import CatalogCompensationSubHierarchy from "./fields/SubHierarchy.vue";
import EventBus from "front-component/EventBus";

const components = {
    Orders,
    CatalogCompensationOwner,
    CatalogCompensationAnabel,
    CatalogCompensationTypeOwner,
    CatalogCompensationHierarchyOwner,
    CatalogCompensationIsValidated,
    CatalogCompensationCatalogCode,
    CatalogCompensationCatalogName,
    CatalogCompensationFormattedWeek,
    CatalogCompensationValidationDeadline,
    CatalogCompensationStoreStatus,
    CatalogCompensationSubHierarchy,
    CatalogCompensationProgram
};

@Component({ components })
export default class List extends StandardList {
    protected route: string = "get_operation";
    protected fields: string[] = [];
    private selectAll: boolean = false;
    private selectedLines: any[] = [];
    public loading: boolean = false;
    public countCampaigns: number = 0;
    public globalBudget: number = 0;

    @Prop( { default: "" }) public hiddenComponent !: string[];
    @Prop( { default: 50}) public limitPerPage !: number;

    @Watch("filters") private cleanSelectedCampaign(): void {
        this.selectedLines = [];
        this.selectAll = false;
        this.retrieveAllFilteredCampaign();
    }

    public mounted() {
        this.retrieveAllFilteredCampaign();
        window.addEventListener("scroll", this.handleScroll);
    }

    public created(): void {
        this.fields = Http.computeStandardFields(components, "catalog");
        EventBus.$on("mass-catalog-status-updated", this.handleMassCatalogStatusUpdated);
    }

    public beforeDestroy(): void {
        EventBus.$off("mass-catalog-status-updated", this.handleMassCatalogStatusUpdated);
        window.removeEventListener("scroll", this.handleScroll);
    }

    private handleMassCatalogStatusUpdated() {
        this.selectedLines = [];
        this.countCampaigns = 0;
        this.refreshList();
        this.retrieveAllFilteredCampaign();
    }

    private retrieveAllFilteredCampaign() {
        const params = { filters: this.filters};
        Http.get(
            "/countallcampaignstovalidate",
            params,
            (data: any) => {
                this.countCampaigns = data[0].catalogCount;
                this.globalBudget = data[0].globalBudget;
            },
            "errorLoadingCampaigns"
        );
    }

    public selectedAll(event: any): void {
        if (event.target.checked) {
            this.selectedLines = _.map(this.elements, "uuid");
        } else {
            this.selectedLines = [];
        }
    }

    private get campaignSelected() {
        return _.filter(this.elements, (campaign: any) => {
            return this.isSelected(campaign.uuid);
        });
    }

    public updateSelected(campaign: any, event: any): void {
        if (event.target.checked) {
            this.selectedLines.push(campaign.uuid);
        } else {
            this.selectedLines = _.filter(this.selectedLines, (selected) => {
                return selected !== campaign.uuid;
            });
            this.selectAll = false;
        }
    }

    public isSelected(uuid: string): boolean {
        return _.some(this.selectedLines, (selected) => {
            return selected === uuid;
        });
    }

    protected link(): string {
        return CatalogCompensationRepository.getSearchUrl();
    }

    @Watch("limitPerPage") public loadExport() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    private launchEdition(uuid: string) {
        this.$emit("show-operation", {uuid});
    }

    private launchValidationCampaignForm() {
        this.$emit("show-validation-campaign", this.campaignSelected);
    }

    private launchValidationForAllCampaignsForm() {
        this.$emit("show-validation-campaign", [], true, this.countCampaigns, this.globalBudget);
    }

    private handleScroll() {
        const fadeElement: any = document.querySelector(".selectedBadge");
        if (window.scrollY > 0) {
            if (fadeElement) {
                fadeElement.style.display = "none";
            }
        } else {
            if (fadeElement) {
                fadeElement.style.display = "block";
            }
        }
    }
}
